import React from 'react';
import { CardGroup, ContentCard, Paper, QuoteCard } from 'library';
import { sortBy } from 'lodash';
import { filterCategoriesByName, filterPostsByCategory } from 'utils/wpUtilities';

import Block from '../../blocks/Block';
import { mapResourceToComponent, mapStoryToComponent } from '../../blocks/CardGroupBlock/cardGroupBlockUtils';
import LoadMore from '../../common/Pagination/LoadMore';
import usePagination from '../../common/Pagination/UsePagination';
import Layout from '../../layout';
import CategoryNav from '../CategoryNav/CategoryNav';

import './CommonFeed.scss';

const CommonFeed = ({ page, data, category, parentTitle, parentSlug }) => {
  const filteredPosts = filterPostsByCategory(page.slug, data.nodes);
  const posts = sortBy(filteredPosts, 'date').reverse();
  const resourcesSlugCheck = parentSlug === 'homeowner-resources';
  const cardSize = resourcesSlugCheck ? ContentCard.size : QuoteCard.size;

  const { hasMoreToLoad, countVisible, handleLoadMore } = usePagination({
    total: posts?.length,
    initialPageCount: resourcesSlugCheck ? 12 : 9,
    incrementLimit: 3,
  });

  const visiblePosts = posts.slice(0, countVisible);

  const renderCards = () => {
    const cards = visiblePosts.map((post, index) => {
      if (resourcesSlugCheck) {
        return <ContentCard {...mapResourceToComponent(post)} key={index} />;
      } else {
        return <QuoteCard {...mapStoryToComponent(post)} key={index} />;
      }
    });

    // Bit of a hack to prevent 4 cards from rendering 2 by 2 in this instance
    if (visiblePosts.length === 4) {
      cards.push(<div></div>);
    }

    return cards;
  };

  return (
    <Layout>
      <Paper theme="medium">
        <CategoryNav
          title={parentTitle}
          activeSlug={page.slug}
          categories={filterCategoriesByName(parentSlug, category.edges)}
        />

        <div className="CommonFeed">
          <CardGroup cardSize={cardSize}>{renderCards()}</CardGroup>
          {hasMoreToLoad && <LoadMore onClick={handleLoadMore} />}
        </div>
        {page.templateFields.blocks?.map((block, index) => (
          <Block data={block} key={index} />
        ))}
      </Paper>
    </Layout>
  );
};

export default CommonFeed;
